<elder-table
  class="flex"
  [data]="configurationsPopulated$ | async"
  [selectionVisible]="true"
  [selectionMultiEnabled]="true"
  (itemClick)="onConfigurationClicked($event)"
  matSort
>
  <elder-data-toolbar
    *elderTableToolbar
    [canAdd]="true"
    [canRemove]="true"
    [canMore]="false"
    (requestNew)="addConfiguration()"
    (requestRemove)="onRemoveConfiguration($event)"
  >
  </elder-data-toolbar>

  <!-- icon -->
  <ng-container matColumnDef="icon">
    <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
    <td mat-cell *matCellDef>
      <mat-icon>label</mat-icon>
    </td>
  </ng-container>

  <!-- property id Column -->
  <ng-container matColumnDef="spec-id">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'properties.property' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration">
      <div class="layout-col" matTooltip="PropertyID: {{ configuration?.spec?.property?.id }}">
        <span>{{ configuration?.spec?.property?.description }}</span>
      </div>
    </td>
  </ng-container>

  <!-- spec operator Column -->
  <ng-container matColumnDef="spec-operator">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'skillSets.constraints.operator' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration">
      {{ 'ConstraintOperator.' + configuration?.spec?.operator | translate }}
    </td>
  </ng-container>

  <!-- value Column -->
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef>{{ 'context.value' | translate }}</th>
    <td mat-cell *matCellDef="let configuration; let i = index">
      <app-constraint-input
        elderStopEventPropagation
        [value]="buildConstraint(configuration)"
        (valueUpdated)="onConfigurationConfUpdated($event, configuration)"
        [name]="'value' + i"
      >
      </app-constraint-input>
    </td>
  </ng-container>

  <!-- spec description Column -->
  <ng-container matColumnDef="spec-description">
    <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
      {{ 'context.description' | translate }}
    </th>
    <td mat-cell *matCellDef="let configuration">{{ configuration?.spec?.description }}</td>
  </ng-container>
</elder-table>
